import { SplitFactoryProvider } from '@splitsoftware/splitio-react';

import { useSplitConfig } from 'hooks/useSplit';
import React from 'react';

const SplitProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { config, userAttributes } = useSplitConfig();

  const canLoadSplit = !!config?.core.authorizationKey;

  if (canLoadSplit) {
    return (
      <SplitFactoryProvider config={config} attributes={userAttributes}>
        {children}
      </SplitFactoryProvider>
    );
  }
  return children;
};

export default SplitProvider;
